import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {
  containerStyles,
  moduleSpacingStyles,
  normalizeStyles,
  typographyStyles
} from '@webs/components-library/theming';
import {ifDefined} from 'lit/directives/if-defined.js';
import {Breadcrumb} from '@webs/components-library/breadcrumbs';
import {IStickyElement, Sticky} from '@webs/components-library/sticky';
import {PropertyValues} from 'lit-element';

@customElement('webs-article-with-sticky-sidebar')
export class ArticleWithStickySidebar extends LitElement {
  static styles = [
    normalizeStyles,
    moduleSpacingStyles,
    typographyStyles,
    containerStyles,
    css`

    ::slotted([slot="title"]),
    .m-article-with-sticky-sidebar__title {
      margin-bottom: 1.2rem !important;
    }

    .desktop-breadcrumbs {
      display: none;
    }

    .m-article-with-sticky-sidebar__left {
        position: relative;
        margin-bottom: 2.05rem;
    }


    .m-article-with-sticky-sidebar__right--suggested-reading {
      margin-top: 4rem;
    }

     @media only screen and (min-width: 768px) {
        .desktop-breadcrumbs {
          display: block;
        }

        .mobile-breadcrumbs {
          display: none;
        }

        ::slotted([slot="title"]),
        .m-article-with-sticky-sidebar__title {
          margin-bottom: 2rem !important;
        }

        .m-article-with-sticky-sidebar__left {
            margin-bottom: 0;
        }

        .sticky-item {
           position: sticky;
           top: 84px;
        }
     }

      @media only screen and (min-width: 1175px) {
        .sticky-item {
           top: 81px;
          }
      }
    `,
  ];

  @property({attribute: 'space-top'})
  spaceTop = 'm';

  @property({attribute: 'space-bottom'})
  spaceBottom = 'm';

  @property()
  id: string;

  @property({attribute: 'sidebar-title'})
  sidebarTitle: string;

  @property()
  breadcrumbs: Breadcrumb[];

  protected render(): unknown {
    return html`
      <section id="${ifDefined(this.id)}"
               class="m-article-with-sticky-sidebar ${this.spaceTop ? 'module_top-padding-' + this.spaceTop : ''} ${this.spaceBottom ? 'module_bottom-padding-' + this.spaceBottom : ''}">
        <div part="container" class="container">
          <webs-grid-row>
            <webs-grid-column sm="4" class="m-article-with-sticky-sidebar__left" data-sticky-container>
              <div class="sticky-item" data-margin-top="80">
                    ${this.breadcrumbs && this.breadcrumbs.length ? html`<webs-breadcrumbs class="mobile-breadcrumbs" items='${this.breadcrumbs}'></webs-breadcrumbs>` : '' }
                    ${this.sidebarTitle ? html`<h2 class="h1 m-article-with-sticky-sidebar__title">${this.sidebarTitle}</h2>` : ''}
                    <slot name="title"></slot>
                    <slot name="card-contact"></slot>
                    <slot name="card-general-single"></slot>
              </div>

            </webs-grid-column>
            <webs-grid-column sm="7" md-offset="1" class="m-article-with-sticky-sidebar__right">
              ${this.breadcrumbs && this.breadcrumbs.length ? html`<webs-breadcrumbs class="desktop-breadcrumbs" items='${this.breadcrumbs}'></webs-breadcrumbs>` : '' }
              <div class="rich-text-container">
                <slot></slot>
                <slot name="card-contact-without-image"></slot>
                <div class="m-article-with-sticky-sidebar__right--suggested-reading">
                  <slot name="suggested-reading"></slot>
                </div>
              </div>
            </webs-grid-column>
          </webs-grid-row>
        </div>
      </section>
    `;
  }

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    this.addScrollEvent();
  }

  private addScrollEvent(): void {
    const mediaWrapper: NodeListOf<IStickyElement> = this.shadowRoot.querySelectorAll<IStickyElement>('.sticky-item');
    const sticky: Sticky = new Sticky(mediaWrapper);
  }
}
